import { getRequest, postRequest } from "./api";

// Get school details
export const getSchoolDetails = async () => {
  return getRequest("/user/schoolDetails");
};

// Save school details
export const saveSchoolDetails = async (formData) => {
  return postRequest("/user/schoolDetails", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Upload school logo
export const uploadSchoolLogo = async (logoFile) => {
  const formData = new FormData();
  formData.append("logo", logoFile);
  return postRequest("/user/schoolDetails", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Upload school header image
export const uploadSchoolHeader = async (headerFile) => {
  const formData = new FormData();
  formData.append("header_image", headerFile);
  return postRequest("/user/schoolDetails", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
